import React, { useState, useEffect } from 'react';
import './App.css';
import LoginScreen from './components/LoginScreen';
import ChatScreen from './components/ChatScreen';
import axios from 'axios';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  const [isValidating, setIsValidating] = useState(true);

  const validateToken = async (tokenToValidate: string): Promise<boolean> => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000'}/auth/validate`,
        {
          headers: {
            'Authorization': `Bearer ${tokenToValidate}`,
          }
        }
      );
      return response.status === 200;
    } catch (error) {
      console.error('Token validation failed:', error);
      return false;
    }
  };

  useEffect(() => {
    const initializeAuth = async () => {
      setIsValidating(true);
      
      // Check URL params first (fresh login)
      const urlParams = new URLSearchParams(window.location.search);
      const tokenFromUrl = urlParams.get('token');
      const error = urlParams.get('error');

      if (error) {
        console.error('OAuth error:', error);
        setIsValidating(false);
        return;
      }

      if (tokenFromUrl) {
        // Validate the new token from URL
        const isValid = await validateToken(tokenFromUrl);
        if (isValid) {
          handleLogin(tokenFromUrl);
        } else {
          console.error('Invalid token received from OAuth');
        }
        window.history.replaceState({}, document.title, window.location.pathname);
        setIsValidating(false);
        return;
      }

      // Check saved token
      const savedToken = localStorage.getItem('auth_token');
      if (savedToken) {
        const isValid = await validateToken(savedToken);
        if (isValid) {
          setToken(savedToken);
          setIsAuthenticated(true);
        } else {
          // Clear invalid token
          localStorage.removeItem('auth_token');
          console.log('Saved token is invalid, cleared from storage');
        }
      }
      
      setIsValidating(false);
    };

    initializeAuth();
  }, []);

  const handleLogin = (authToken: string) => {
    setToken(authToken);
    setIsAuthenticated(true);
    localStorage.setItem('auth_token', authToken);
  };

  const handleLogout = () => {
    setToken(null);
    setIsAuthenticated(false);
    localStorage.removeItem('auth_token');
  };

  // Show loading while validating token
  if (isValidating) {
    return (
      <div className="App">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          fontSize: '18px',
          color: '#666'
        }}>
          Validating your authentication...
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {!isAuthenticated ? (
        <LoginScreen onLogin={handleLogin} />
      ) : (
        <ChatScreen token={token!} onLogout={handleLogout} />
      )}
    </div>
  );
}

export default App;